import React, { Component } from 'react';
import '../App.css';


class WikipediaENG extends Component {
  render() {
    if (Object.keys(this.props.content).length > 0) {
      const results = this.props.content.map((content, i) =>
      <div key={i} className="WikiContent">
        <div className="WikiHeader_bot">
          <a href={content[2]} target="_blank">
            {content[0]}
          </a>
        </div>
        <p>{content[1]}</p>
      </div>)
      return (
        <div className="WikiResults">
          <div>
            <div className="WikiHeader_top">Wikipedia:</div>
            {results}
          </div>
        </div>
      );
    } else {
      return (
        <div className="WikiResults">
          <div>
            <div className="WikiHeader_top">Wikipedia:</div>
            <div className="WikiContent">
              This search gave 0 results
            </div>
          </div>
        </div>
      );
    }
  }
}

export default WikipediaENG;



// WEBPACK FOOTER //
// ./client/src/Engines/WikipediaENG.js